(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function() {
  var bar = document.getElementById('tm-sticky-bar-3');
  if (!bar) return;

  var waMessages = [
    'Get Extra Discount on WhatsApp Orders Only',
    'FREE 10ml Perfume with Your First Order'
  ];
  var waIdx = 0;
  var waEl = document.getElementById('tmWaText3');

  function rotateWa() {
    if (!waEl) return;
    waEl.classList.add('out');
    setTimeout(function() {
      waIdx = (waIdx + 1) % waMessages.length;
      waEl.textContent = waMessages[waIdx];
      waEl.classList.remove('out');
      waEl.classList.add('in');
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { waEl.classList.remove('in'); });
      });
    }, 350);
  }
  if (waEl) setInterval(rotateWa, 3000);

  function hideStickyBar() { bar.style.setProperty('display', 'none', 'important'); }
  function showStickyBar() { bar.style.removeProperty('display'); }

  document.querySelectorAll('details').forEach(function(el) {
    new MutationObserver(function() {
      var anyOpen = Array.from(document.querySelectorAll('details')).some(function(d) {
        return d.hasAttribute('open');
      });
      anyOpen ? hideStickyBar() : showStickyBar();
    }).observe(el, { attributes: true, attributeFilter: ['open'] });
  });

  new MutationObserver(function() {
    var c = document.body.className;
    if (c.includes('menu-open') || c.includes('js-menu-open') ||
        c.includes('overflow-hidden') || c.includes('drawer-open')) {
      hideStickyBar();
    } else {
      showStickyBar();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  var minus = document.getElementById('tmMinus3');
  var plus  = document.getElementById('tmPlus3');
  var qtyEl = document.getElementById('tmQty3');

  function syncQty(v) {
    v = Math.min(Math.max(v, 1), 10);
    if (qtyEl) qtyEl.textContent = v;
  }
  if (minus && plus && qtyEl) {
    minus.addEventListener('click', function() { syncQty(parseInt(qtyEl.textContent || '1') - 1); });
    plus.addEventListener('click',  function() { syncQty(parseInt(qtyEl.textContent || '1') + 1); });
  }

  function updateVariant(variant) {
    if (!variant) return;
    var priceEl = document.getElementById('tmPrice3');
    var textEl  = document.getElementById('tmAtcText3');
    var atcBtn  = document.getElementById('tmAtcBtn3');
    if (priceEl) priceEl.textContent = 'Rs. ' + (variant.price / 100).toFixed(2);
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.style.opacity = variant.available ? '1' : '0.5';
      if (textEl) textEl.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  document.addEventListener('variant:change', function(e) {
    updateVariant(e.detail && e.detail.variant);
  });

  var idInput = document.querySelector('[name="id"]');
  if (idInput) {
    idInput.addEventListener('change', function() {
      fetch('/variants/' + this.value + '.js')
        .then(function(r) { return r.json(); })
        .then(updateVariant);
    });
  }

  var atcBtn = document.getElementById('tmAtcBtn3');
  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      var variantInput = document.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) { alert('Please select a size'); return; }

      var qty = parseInt((qtyEl || {}).textContent || '1');
      var textEl = document.getElementById('tmAtcText3');

      if (textEl) textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value),
          quantity: qty
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (textEl) textEl.textContent = 'Added ✓';

        // ── OPEN GOKWIK CART ──
        if (window.gokwik && typeof window.gokwik.openCart === 'function') {
          window.gokwik.openCart();
        } else if (window.GokwikSdk && typeof window.GokwikSdk.openCart === 'function') {
          window.GokwikSdk.openCart();
        } else {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('gokwik:cart:updated', {
                detail: cart, bubbles: true
              }));
              var gkCart =
                document.querySelector('[class*="gokwik"][class*="cart"]') ||
                document.querySelector('[id*="gokwik"][id*="cart"]') ||
                document.querySelector('gokwik-cart') ||
                document.querySelector('[data-gokwik]');
              if (gkCart) gkCart.click();
            });
        }

        setTimeout(function() {
          if (textEl) textEl.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function(err) {
        console.error('ATC error:', err);
        if (textEl) textEl.textContent = 'Add to Cart';
        alert('Something went wrong. Please try again.');
      });
    });
  }

})();


  } catch(e) { console.error(e); }
})();
})();
